import { Injectable } from '@angular/core';
// import * as faker from 'faker';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';
import { CurrentUserService } from '../current-user.service';
import { SchemeService } from './scheme.service';
// import * as querystring from 'querystring';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
// import moment = require('moment');
import { PMKVY_SCHEME_MODEL_CONSTANTS, USER_ROLES } from 'src/app/scheme-constants/scheme-constants';
import { ActivatedRoute } from '@angular/router';
import { flatMap, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators'
export const ASSESSOR_STATUS = {
	REGISTRATION_COMPLETED: 'registrationCompleted',
	REGISTRATION_INCOMPLETED: 'registrationInComplete',
	INCOMPLETE: 'incomplete'
};
@Injectable({ providedIn: 'root' })
export class TrainingPartnerService {
	tpTypeCheckForSchemRule: { createProject: boolean, govError: boolean, nonGovError: boolean } =
		{ createProject: false, govError: false, nonGovError: false }
	constructor(
		private apiService: ApiService,
		private currentUserService: CurrentUserService,
		private schemeService: SchemeService,
		private route: ActivatedRoute,
	) { }

	selectScheme(scheme) {
		const user = this.currentUserService.getCurrentUserLocal().value;
		const role = user.role;
		const userName = user.userName;
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/${userName}/scheme`;
		// const url = `${environment.userServiceUrl}/user/${role}/${userName}`;
		return this.apiService.patch(url, scheme);
	}

	reSubmitSelectedScheme(scheme) {
		const user = this.currentUserService.getCurrentUserLocal().value;
		const role = user.role;
		const userName = user.userName;
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/${userName}/resubmitscheme`;
		return this.apiService.put(url, scheme);
	}

	getSchemesWithStatus(status: string = 'all') {
		const user = this.currentUserService.getCurrentUserLocal().value;
		const role = user.role;
		const userName = user.userName;
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/${userName}/schemes/${status}`;
		return this.apiService.get(url);
	}

	getAllSelectedSchemeSectorWorkflow({ pageNo = 1, limit = 20 } = {}) {
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/GetSectorsWorkflow?pageNo=${pageNo}&limit=${limit}`;
		return this.apiService.get(url);
	}

	getAllSelectedSchemeSectorWorkflowV2({
		pageNo = 1,
		limit = 20,
		filter = {}
	} = {}) {
		const backEndQuery = Helpers.toBackendQuery(filter);
		// if (backEndQuery !== '') {
		// 	limit = 1000;
		// }
		// else
		// {
		// 	limit=10;
		// }
		const query = {};
		Object.assign(query, {
			pageNo,
			limit,
			query: backEndQuery
		});
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/SectorWorkflows`;
		// }/api/user/v1/trainingpartner/FeeBasedScheme/SectorWorkflows?pageNo=${pageNo}&limit=${limit}`;
		return this.apiService.get(url, query);
	}

	getFeeBasedSchemeSector(tpId, selectedSchemeId, uniqueId) {
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/GetSector?query=tpId:${tpId},id:${selectedSchemeId},uniqueID:${uniqueId}`;
		return this.apiService.get(url);
	}

	getFeeBasedSchemeCourse(
		tpId,
		selectedSchemeId,
		selectedSectorId,
		uniqueId
	) {
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/GetCourse?
			tpId=${tpId}&schemeID=${selectedSchemeId}&SectorID=${selectedSectorId}&UniqueID=${uniqueId}`;
		return this.apiService.get(url);
	}

	getFeeBasedSchemeCourseV2(
		tpId,
		selectedSchemeId,
		selectedSectorId,
		uniqueId
	) {
		const user = this.currentUserService.getCurrentUserLocal().value;
		tpId = tpId || user.userName;
		const backEndQuery = {
			uniqueID: uniqueId,
			tpId
		};
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/GetCourse/v2?
			query=${Helpers.toBackendQuery(backEndQuery)}`;
		// uniqueID:${uniqueId}`;
		return this.apiService.get(url);
	}

	getAllSelectedSchemeCourseWorkflow({
		pageNo = 1,
		limit = 20,
		filter = {}
	} = {}) {
		const backEndQuery = Helpers.toBackendQuery(filter);
		// if (backEndQuery !== '') {
		// 	limit = 1000;
		// }
		const query = {
			pageNo,
			limit,
			query: backEndQuery
		};

		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/CoursesWorkflows`;
		// }/api/user/v1/trainingpartner/FeeBasedScheme/CoursesWorkflows?pageNo=${pageNo}&limit=${limit}`;
		return this.apiService.get(url, query);
	}

	updateSectorWorkflow(
		data,
		{ workflowId, status, tpId, schemeId, sectorReferenceId }
	) {
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/SectorWorkflow?
			workflowId=${workflowId}&status=${status}&tpId=${tpId}&schemeID=${schemeId}&sectorReferenceID=${sectorReferenceId}`;
		return this.apiService.post(url, data);
	}

	updateCourseWorkflow(
		data,
		{ workflowId, status, tpId, schemeId, uniqueId, sectorReferenceId }
	) {
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/CoursesWorkflow?
			workflowId=${workflowId}&status=${status}&tpId=${tpId}&schemeID=${schemeId}&UniqueID=${uniqueId}&sectorReferenceID=${sectorReferenceId}`;
		return this.apiService.post(url, data);
	}

	addTrainingCentre(trainingcentre) {
		const url = `${environment.userServiceUrl
			}/api/user/v1/register/Training Centre`;
		return this.apiService.post(url, trainingcentre);
	}

	resubmitTrainingCentre(trainingcentre, tcId) {
		// const url = `http://localhost:3000/api/user/v1/trainingpartner/FeeBasedScheme/ResubmitTrainingCentre?tcId=TC28`
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/ResubmitTrainingCentre?tcId=${tcId}`;
		return this.apiService.put(url, trainingcentre);
	}

	getTrainingpartner(tpId) {
		const url = `${environment.userServiceUrl}/api/user/v1/trainingpartner/${tpId}`
		return this.apiService.get(url);
	}

	submitTcForApproval(data) {
		const url = `${environment.userServiceUrl
			}/api/user/v1/submitForApproval`;
		return this.apiService.post(url, data);
	}

	getAssessor(assessorId, status = '') {
		const param = Helpers.serialize({
			status
		});
		const url = `${environment.userServiceUrl
			}/api/user/v1/assessor/${assessorId}?${param}`;
		return this.apiService.get(url);
	}

	getProctor(proctorId, status = '') {
		const param = Helpers.serialize({
			status
		});
		const url = `${environment.userServiceUrl
			}/api/user/v1/proctor/${proctorId}?${param}`;
		return this.apiService.get(url);
	}

	getProctors(
		{ pageNo = 1, limit = 20, pagination = 'yes', keyword = '', linked = false }: any = {},
		{ district = '', state = '', proctorId = '', regStatus = '', phone = '' }: any = {}, withoutPagination: boolean = false,

	) {
		const queryObject: any = {
			pageNo,
			limit,
			pagination,
			linked,
			district,
			state,
			proctorId,
			regStatus,
			phone
		};
		console.log(queryObject)
		if (withoutPagination) {
			queryObject.pagination = 'no';
		}
		if (keyword) {
			queryObject.keyword = keyword;
		}
		const query = Helpers.serialize(queryObject);
		console.log(query)
		// const url = `${environment.userServiceUrl}/api/user/v1/assessor/assessmentagency/getlinkedassessors?${query}`;
		const url = `${environment.userServiceUrl}/api/user/v1//proctor/getproctors?${query}`;
		return this.apiService.get(url);
	}

	getAssessorAssociation(selectedSchemeId: string, assessorId: string) {
		const url = `${environment.userServiceUrl
			}/api/user/v1/assessor/get/association/${selectedSchemeId}/${assessorId}`;
		return this.apiService.get(url);
	}

	declerationPage(requestType: Boolean) {
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/reda/process`;
		return this.apiService.post(url, { isReDAPayment: requestType }, true);
	}

	canapplyforreda() {
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/apply/reda`;
		return this.apiService.get(url);
	}

	updateAssessorAssociation(
		selectedSchemeId: string,
		assessorId: string,
		association: any
	) {
		const url = `${environment.userServiceUrl
			}/api/user/v1/assessor/update/association/${selectedSchemeId}/${assessorId}`;
		return this.apiService.put(url, association);
	}

	// downloaderrorsheet(data) {
	// 	const url = `${environment.userServiceUrl}/v1/candidates/download/pdf`;

	// 	return this.apiService.postPdf(url, {badData: data});
	// }

	getTrainerAssociation(selectedSchemeId: string, trainerId: string, tcId?, validity?) {
		const url = `${environment.trainingPartnerServiceURL
			}/api/trainingpartnerservice/v1/tr/${trainerId}/scheme/${selectedSchemeId}/association?tcId=${tcId ? tcId : ''}&fromDate=${validity ? validity.fromDate : null}&toDate=${validity ? validity.toDate : null}`;
		return this.apiService.get(url);
	}

	updateTrainerAssociation(
		selectedSchemeId: string,
		trainerId: string,
		association: any
	) {
		const url = `${environment.trainingPartnerServiceURL
			}/api/trainingpartnerservice/v1/tr/${trainerId}/scheme/${selectedSchemeId}/association`;
		return this.apiService.put(url, association);
	}

	updateAssociatedTrainerDetails(trainerData) {
		const url = `${environment.trainingPartnerServiceURL
			}/api/trainingpartnerservice/v1/trainingpartner/trainer/update/${trainerData.trainerId}`;
		return this.apiService.put(url, trainerData);
	}

	getAssessors(
		{ pageNo = 1, limit = 20, pagination = 'yes', keyword = '' }: any = {},
		withoutPagination: boolean = false
	) {
		const queryObject: any = {
			pageNo,
			limit,
			pagination
		};
		if (withoutPagination) {
			queryObject.pagination = 'no';
		}
		if (keyword) {
			queryObject.keyword = keyword;
		}
		const query = Helpers.serialize(queryObject);
		const url = `${environment.userServiceUrl
			}/api/user/v1/assessor/assessmentagency/getlinkedassessors?${query}`;
		return this.apiService.get(url);
	}

	getAssessmentAgencies(
		{ pageNo = 1, limit = 20, pagination = 'yes' }: any = {},
		withoutPagination: boolean = false
	) {
		const queryObject = {
			pageNo,
			limit,
			pagination,
			type: 'Feebased'
		};
		if (withoutPagination) {
			queryObject.pagination = 'no';
		}
		const query = Helpers.serialize(queryObject);
		const url = `${environment.userServiceUrl
			}/api/user/v1/assessmentAgency?${query}`;
		return this.apiService.get(url);
	}

	linkAssessor(assessorId, data, phone_otp, email_otp) {
		const query = Helpers.serialize({
			phone_otp,
			email_otp
		});
		// let url = null;
		// if (selectedSchemeId && selectedSchemeId !== undefined && selectedSchemeId !== '') {
		// 	url = `${
		// 		environment.userServiceUrl
		// 		}/api/user/v1/assessor/linkassessortoassessmentagency/${selectedSchemeId}/${assessorId}?${query}`;
		// } else {
		const url = `${environment.userServiceUrl}/api/user/v1/assessor/link/assessorto/assessmentagency/${assessorId}?${query}`;
		// }

		// }/api/user/v1/assessor/linkassessortoassessmentagency/${selectedSchemeId}/${assessorId}`;
		return this.apiService.post(url, data);
	}

	linkProctor(proctorId, data, phone_otp, email_otp) {
		const query = Helpers.serialize({
			phone_otp,
			email_otp
		});
		// let url = null;
		// if (selectedSchemeId && selectedSchemeId !== undefined && selectedSchemeId !== '') {
		// 	url = `${
		// 		environment.userServiceUrl
		// 		}/api/user/v1/assessor/linkproctortoassessmentagency/${selectedSchemeId}/${proctorId}?${query}`;
		// } else {
		const url = `${environment.userServiceUrl}/api/user/v1/proctor/link/proctorto/assessmentagency/${proctorId}?${query}`;
		// }

		// }/api/user/v1/proctor/linkproctortoassessmentagency/${selectedSchemeId}/${assessorId}`;
		return this.apiService.post(url, data);
	}

	getTrainers(
		tpId?: string,
		{ pageNo = 1, limit = 20, pagination = 'yes', keyword = '', onlyActive = true }: any = {},
		withoutPagination: boolean = false
	) {
		const user = this.currentUserService.getCurrentUserLocal().value;
		tpId = tpId || user.userName;
		const query: any = {};
		Object.assign(query, {
			pageNo,
			limit,
			pagination
		});
		if (withoutPagination) {
			query.pagination = 'no';
		}
		if (keyword) {
			query.keyword = keyword;
		}
		if (onlyActive) {
			query.onlyActive = true;
		}
		const queryString = Helpers.serialize(query);
		// const queryObject = {
		// 	pageNo,
		// 	limit,
		// 	pagination
		// };
		// if (withoutPagination) {
		// 	queryObject.pagination = 'no';
		// }
		// const queryString = Helpers.serialize(queryObject);
		// http://localhost:3021/api/trainingpartnerservice/v1/trainingpartner/TP168/trainers?keyword=TR13hgvhg
		// const url = `${
		// 	environment.trainingPartnerServiceURL
		// }/api/trainingpartnerservice/v1/trainingpartner/${tpId}/trainers?${queryString}`;
		const url = `${environment.trainingPartnerServiceURL
			}/api/trainingpartnerservice/v1/trainingpartner/${tpId}/trainers`;
		return this.apiService.get(url, query);
	}

	createAssessmentAgency(data) {
		const url = `${environment.userServiceUrl
			}/api/user/v1/register/Assessment Agency`;
		return this.apiService.post(url, data);
	}

	putDaReviewOnSelectedScheme(
		workflowId: string,
		tpUserId: string,
		selectedSchemeId: string,
		status: boolean,
		review: any,
		groupReviews: any,
		revenue?: any,
		blockchain?:any
	) {
		const reviewComments = JSON.stringify(review);
		const user = this.currentUserService.getCurrentUserLocal().value;
		const role = user.role;
		const userName = user.userName;
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/${userName}/scheme/review?${Helpers.serialize(
				{
					selectedSchemeId,
					workflowId,
					userName: tpUserId
				}
			)}`;
		return this.apiService.patch(url, { status, reviewComments, groupReviews, revenue, blockchain });
	}

	getSchemesDetailsWitStatus(status: string) {
		return this.getSchemesWithStatus(status)
			.pipe(map(
				(data: any) =>
					(data &&
						data.schemes.filter(
							scheme => scheme.schemeReferenceId
						)) ||
					[]
			)
				, flatMap(schemes => {
					const trainingPartnerSubscriptions = schemes.map(scheme => {
						// return this.schemeService.getSchemeForParticularSchemeID(
						// 	scheme.schemeReferenceId,
						// 	undefined,
						// 	// scheme.ruleId,
						// 	{
						// 		daReviews: scheme.daReviews,
						// 		duration: scheme.duration,
						// 		selectedSchemeId: scheme._id,
						// 		projectName: scheme.project && scheme.project.name
						// 	}
						// );
					});
					return forkJoin(trainingPartnerSubscriptions);
				}));
	}
	/**
	 * Get
	 * Projects List for selected scheme
	 */
	getFeeBasedSelectedSchemesBySchemeId(
		schemeReferenceId: string,
		scheme: { name: string, status?: string, type?: any },
		tpId?: string,
		tcId?: string,
		pageNum?: number,
		limit?: number,
		status?: string,
		userRole?: string
	) {
		const user = this.currentUserService.getCurrentUserLocal().value;
		const role = userRole || user.role;
		tpId = tpId || user.userName;
		const query = {
			tpID: tpId,
			schemeRefrenceId: schemeReferenceId,
			trainingType: scheme.type ? scheme.type : '',
			pageNo: pageNum ? pageNum : 1,
			limit: limit ? limit : 100,
		};
		if (tcId) {
			query['tcId'] = tcId;
		}
		if (status) {
			query['status'] = status
		}
		if (role) {
			query['role'] = role;
		}
		console.log('userNAme', query, tpId, query.tpID);
		const url = `${environment.userServiceUrl}/api/user/v1/trainingpartner/${scheme.name}/GetSchemes?${Helpers.serialize(query)}`;
		console.log(url);
		console.log(query);

		return this.apiService.get(url);
		// ```localhost:3000/api/user/v1/trainingpartner/FeeBasedScheme/GetSchemes?tpID=TP332&schemeRefrenceId=1```
	}

	createTPSchemeLogo(data) {
		const url = `${environment.batchServiceUrl}/api/v1/cert/logoupload/newlogo`;
		return this.apiService.post(url, data);
	}

	getTPSchemeLogoRequest(data?) {
		const url = `${environment.batchServiceUrl}/api/v1/cert/logoupload/logorequests`;
		return this.apiService.get(url, data);
	}

	updateTPSchemeLogoStatus(data) {
		const url = `${environment.batchServiceUrl}/api/v1/cert/logoupload/updatelogostatus`;
		return this.apiService.post(url, data)
	}


	getFeeBasedSelectedSchemesBySchemeIdFDA(
		schemeReferenceId: string,
		scheme: { name: string, status?: string, type?: any },
		tpId?: string,
		tcId?: string,
		pageNum?: number,
		limit?: number,
	) {
		const query = {
			tpID: tpId,
			schemeRefrenceId: schemeReferenceId,
			trainingType: scheme.type ? scheme.type : '',
			pageNo: pageNum ? pageNum : 1,
			limit: limit ? limit : 10,
		};
		if (tcId) {
			query['tcId'] = tcId;
		}
		// query['role'] = 'Training Partner';
		const url = `${environment.userServiceUrl}/api/user/v1/trainingpartner/${scheme.name}/GetSchemes?${Helpers.serialize(query)}`;
		return this.apiService.get(url);
	}

	getSelectedScheme(selectedSchemeId: string, userName?: string, userRole?: string, isJss?:any) {
		const user = this.currentUserService.getCurrentUserLocal().value;
		const role = userRole || user.role === 'SEO' ? 'Training Partner' : user.role;
		userName = userName || user.userName;
		let url = role ? `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/${userName}/scheme/${selectedSchemeId}?role=${role}&forJSS=${isJss}`
			: `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/${userName}/scheme/${selectedSchemeId}`;
		return this.apiService.get(url);
	}

	getProjectSummary(userName: string, selectedSchemeId: string,) {
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/${userName}/scheme/${selectedSchemeId}/summary`;
		return this.apiService.get(url);
	}

	getSpocSchemeData(schemeId, userName) {
		const URL = `${environment.userServiceUrl}/api/user/v1/ssc/scheme/spoc/get/schemes?schemeId=${schemeId}&userName=${userName}`
		return this.apiService.get(URL);
	}

	getSchemes() {
		const url = `${environment.schemeServiceURL
			}/api/schemes/v1/schemes/Approved/Active/rule/Approved?fields=`;
		// const url = `${environment.schemeServiceURL}/api/schemes/v1/schemes/active/rule/Approved`;
		// const url = `${environment.schemeServiceURL}/api/schemes/v1`;
		return this.apiService.get(url).pipe(map((schemes = []) => {
			if (!(schemes instanceof Array)) {
				schemes = [];
			}
			schemes = schemes || [];
			// schemes = schemes.filter((scheme: Object) => {
			// 	return scheme.hasOwnProperty('isPayoutAdviceRequiredisPayoutAdviceRequired');
			// });
			schemes.map(scheme => {
				// scheme.type = scheme.isPayoutAdviceRequired ? 'pmkvy' : 'feeBased';
				// scheme.type = scheme.isPmkvyDriven ? 'pmkvy' : 'feeBased';
				let feeAmount =
					scheme.trainingPartnerDetails &&
					scheme.trainingPartnerDetails[0].registrationFeeAmount;
				feeAmount = parseFloat(feeAmount);
				feeAmount = String(feeAmount) === 'NaN' ? 0 : feeAmount;
				scheme.trainingPartnerRegistrationFee = feeAmount;
				return scheme;
			});
			return schemes;
		}));
	}

	latestSchemeReview(scheme) {
		const latestDaReview = scheme.daReviews && scheme.daReviews.pop();
		const review = latestDaReview && JSON.parse(latestDaReview.review);
		return review;
	}

	// getSchemess(count = 10) {
	// 	const schemes = [];
	// 	for (let i = 0; i < count; i++) {
	// 		schemes.push(this._generateRandomSchemeDetail());
	// 	}
	// 	return schemes;
	// }

	createFeeBasedSector(selectedSchemeId, data) {
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/AddSector/${selectedSchemeId}`;
		return this.apiService.post(url, data);
	}

	createFeeBasedSectorV2(selectedSchemeId, data) {
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/AddSector/${selectedSchemeId}`;
		return this.apiService.post(url, data);
	}

	createFeeBasedCourse(selectedSchemeId, course) {
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/AddCourse/${selectedSchemeId}`;
		return this.apiService.post(url, course);
	}

	createFeeBasedCourseV2(selectedSchemeId, course) {
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/AddCourse/v2/${selectedSchemeId}`;
		return this.apiService.post(url, course);
	}

	patchFeeBasedCourseV2(selectedSchemeId, course) {
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/AddCourse/v2/${selectedSchemeId}`;
		return this.apiService.patch(url, course);
	}

	updateFeeBasedCourseV2(selectedSchemeId, course) {
		const url = `${environment.userServiceUrl}/api/user/v1/trainingpartner/FeeBasedScheme/UpdateCourse/v2/${selectedSchemeId}`;
		return this.apiService.put(url, course);
	}

	getSelectedSchemeSectors(
		selectedSchemeId: string,
		tpId?: string,
		{
			pageNo = 1,
			limit = 100,
			pagination = 'yes',
			backEndQuery,
			onlyApproved = false
		}: any = {},
		withoutPagination: boolean = false
	) {
		const user = this.currentUserService.getCurrentUserLocal().value;
		const APPROVED_SECTOR = 'ACCEPTED';
		tpId = tpId || user.userName;
		backEndQuery = backEndQuery || {};
		backEndQuery.tpId = tpId;
		backEndQuery.id = selectedSchemeId;
		// backEndQuery['showInactive'] = false;
		if (onlyApproved) {
			backEndQuery.status = APPROVED_SECTOR;
		}
		const queryObject = {
			pageNo,
			limit,
			pagination
		};
		if (withoutPagination) {
			queryObject.pagination = 'no';
			delete queryObject.pageNo;
			delete queryObject.limit;
		}
		backEndQuery = Helpers.toBackendQuery(backEndQuery);
		const query = Helpers.serialize(queryObject);
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/GetSectors?query=${backEndQuery}&${query}`;
		// }/api/user/v1/trainingpartner/FeeBasedScheme/GetSectors?query=tpId:${tpId},id:${selectedSchemeId}&${query}`;
		// }/api/user/v1/trainingpartner/FeeBasedSector/GetSectors?query=tpId:${tpId},id:${selectedSchemeId}`;
		return this.apiService.get(url);
	}

	getSelectedSchemeCourses(
		selectedSchemeId: string,
		tpId?: string,
		{ pageNo = 1, limit = 20, pagination = 'yes' }: any = {},
		withoutPagination: boolean = false
	) {
		const user = this.currentUserService.getCurrentUserLocal().value;
		tpId = tpId || user.userName;
		const queryObj = {
			schemeID: selectedSchemeId,
			tpId: tpId,
			pageNo,
			limit,
			pagination
		};
		if (withoutPagination) {
			queryObj.pagination = 'no';
			delete queryObj.pageNo;
			delete queryObj.limit;
		}
		const query = Helpers.serialize(queryObj);
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/GetCourses?${query}`;
		// }/api/user/v1/trainingpartner/FeeBasedScheme/GetCourses?tpId=${tpId}&schemeID=${selectedSchemeId}`;
		return this.apiService.get(url);
	}

	getSelectedSchemeCoursesV2(
		selectedSchemeId: string,
		tpId?: string,
		{ pageNo = 1, limit = 20, pagination = 'yes', backEndQuery }: any = {},
		withoutPagination: boolean = false
	) {
		backEndQuery = backEndQuery || {};
		const user = this.currentUserService.getCurrentUserLocal().value;
		tpId = tpId || user.userName;
		Object.assign(backEndQuery, {
			tpId: tpId,
			schemeID: selectedSchemeId
		});
		// backEndQuery.tpId = tpId;
		backEndQuery = Helpers.toBackendQuery(backEndQuery);
		const queryObj = {
			pageNo,
			limit,
			pagination
		};
		if (withoutPagination) {
			queryObj.pagination = 'no';
			delete queryObj.pageNo;
			delete queryObj.limit;
		}
		const query = Helpers.serialize(queryObj);
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/GetCourses/v2?query=${backEndQuery}&${query}`;
		// }/api/user/v1/trainingpartner/FeeBasedScheme/GetCourses/v2?query=tpId:${tpId},schemeID:${selectedSchemeId}&${query}`;
		return this.apiService.get(url);
	}

	getSelectedSectorCourses(
		selectedSchemeId: string,
		sectorID: string,
		tpId?: string
	) {
		const user = this.currentUserService.getCurrentUserLocal().value;
		tpId = tpId || user.userName;

		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/GetCourses/v2?query=tpId:${tpId},schemeID:${selectedSchemeId},sectorID:${sectorID}`;
		return this.apiService.get(url);
	}

	// private _generateRandomSchemeDetail() {
	// 	return {
	// 		id: faker.random.uuid(),
	// 		logoUrl: faker.internet.avatar(),
	// 		name: faker.name.title(),
	// 		details: faker.lorem.paragraphs(),
	// 		requiredDocuments: [
	// 			faker.lorem.sentence(),
	// 			faker.lorem.sentence(),
	// 			faker.lorem.sentence()
	// 		],
	// 		preRequisites: [
	// 			faker.lorem.sentence(),
	// 			faker.lorem.sentence(),
	// 			faker.lorem.sentence()
	// 		],
	// 		fee: faker.random.number(),
	// 		for: 'Add Scheme'
	// 	};
	// }

	submitUserRegistrationForm(body, role, userName) {
		const submitAPIUrl =
			environment.userServiceUrl +
			'/api/user/v1/update/' +
			role +
			'/' +
			userName;
		return this.apiService.patch(submitAPIUrl, body, true);
	}

	updateTpRegistration(body, role, userName) {
		const submitAPIUrl =
			environment.userServiceUrl +
			'/api/user/v1/update/' +
			role +
			'/' +
			userName;
		return this.apiService.post(submitAPIUrl, body, true);
	}

	submitTpPaymentOnly(role?: string, userName?: string) {
		const user = this.currentUserService.getCurrentUserLocal().value;
		role = role || user.role;
		userName = userName || user.userName;
		const body = {
			redirectUrl: 'registration',
		}
		const submitAPIUrl =
			environment.userServiceUrl +
			'/api/user/v1/update/' +
			role +
			'/' +
			userName +
			`?payment=true`;
		return this.apiService.patch(submitAPIUrl, body, true);
	}

	getTrainingPartners() {
		// localhost:3000/api/user/v1/trainingpartners?pagination=no&param=trainingPartner,userName
		const url =
			environment.userServiceUrl +
			'/api/user/v1/trainingpartners?pagination=no&param=firstName,lastName,userName';
		return this.apiService.get(url);
	}

	deleteSchemeSectors(sectorUniqueIds = []) {
		const user = this.currentUserService.getCurrentUserLocal().value;
		const userName = user.userName;
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/sectors`;
		const body = sectorUniqueIds.map(sectorUniqueId => {
			return {
				uniqueID: sectorUniqueId,
				tpId: userName,
				status: 'deleted',
				remarks: `deleted by ${userName} before resubmitting scheme`
			};
		});
		return this.apiService.post(url, body);
	}

	deleteSchemeCourses(courseUniqueIds = []) {
		const user = this.currentUserService.getCurrentUserLocal().value;
		const userName = user.userName;
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/FeeBasedScheme/courses`;
		const body = courseUniqueIds.map(courseUniqueId => {
			return {
				uniqueID: courseUniqueId,
				tpId: userName,
				status: 'deleted',
				remarks: `deleted by ${userName} before resubmitting scheme`
			};
		});
		return this.apiService.post(url, body);
	}

	getCandidates({ pageNo = 1, limit = 10 } = {}, tpId?: string) {
		// const user = this.currentUserService.getCurrentUserLocal().value;
		// const userName = user.userName;
		const url =
			tpId ?
				`${environment.userServiceUrl}/v1/candidates/list/all/fetch
						?tpId=${tpId}&pageNo=${pageNo}&amp;limit=${limit}&amp;sortBy=candidateId&amp;sortOrder=1` :
				`${environment.userServiceUrl}/v1/candidates/list/all/fetch
						?pageNo=${pageNo}&amp;limit=${limit}&amp;sortBy=candidateId&amp;sortOrder=1`;
		return this.apiService.post(url);
	}
	getCandidatesV1({ pageNo = 1, limit = 10 } = {}, tpId?: string) {
		// const user = this.currentUserService.getCurrentUserLocal().value;
		const queryParams = {};
		queryParams['createdBy'] = [tpId];
		// const userName = user.userName;
		const url =
			tpId ?
				`${environment.userServiceUrl}/v1/candidates/pmkvy/candidates/list
						?tpId=${tpId}&pageNo=${pageNo}&amp;limit=${limit}&amp;sortBy=candidateId&amp;sortOrder=1` :
				`${environment.userServiceUrl}/v1/candidates/pmkvy/candidates/list
						?pageNo=${pageNo}&amp;limit=${limit}&amp;sortBy=candidateId&amp;sortOrder=1`;
		return this.apiService.post(url, queryParams);
	}

	getFilterCandidates({ pageNo = 1, limit = 10 } = {}, tpId?: string, filterData?) {
		// const user = this.currentUserService.getCurrentUserLocal().value;
		// const userName = user.userName;
		const url =
			tpId ?
				`${environment.userServiceUrl}/v1/candidates/list/all/fetch
						?tpId=${tpId}&pageNo=${pageNo}&amp;limit=${limit}&amp;sortBy=candidateId&amp;sortOrder=1&startDate=${filterData.startDate.toISOString()}&endDate=${filterData.endDate.toISOString()}` :
				`${environment.userServiceUrl}/v1/candidates/list/all/fetch
						?pageNo=${pageNo}&amp;limit=${limit}&amp;sortBy=candidateId&amp;sortOrder=1&startDate=${filterData.startDate}&endDate=${filterData.endDate}`;
		return this.apiService.post(url);
	}

	downloadSelectedCandidateInFile(candidatesIDs: string[]) {
		// const user = this.currentUserService.getCurrentUserLocal().value;
		// const userName = user.userName;
		const url = `${environment.userServiceUrl
			}/v1/candidates/list/selected/download?isPMV=true`;
		const type = 'application/vnd.ms-excel';
		return this.apiService.getBlobOnArguments(
			url,
			{
				candidatesIDs
			},
			type
		);
	}


	downloaderrorsheet(data) {
		const url = `${environment.userServiceUrl}/v1/candidates/download/pdf`;

		const type = 'application/x-pdf';
		return this.apiService.getBlobOnArguments(
			url,
			{
				badData: data
			},
			type
		);
	}


	searchCandidates(
		{ pageNo = 1, limit = 10, keyword = '' },
		filters?: ICandidateFilter
	) {
		/* searchs:-
			candidatesIDs,
			state,
			district,
			createdOn
		*/

		filters = Object.keys(filters)
			.filter(filter => filters[filter])
			.reduce((finalFilter, filterKey) => {
				finalFilter[filterKey] = filters[filterKey];
				return finalFilter;
			}, {});
		if (filters.createdBy || filters.locationSpoc || filters.candidateId || filters.tpId || filters.srcofregister) {
			const url = `${environment.userServiceUrl}/v1/candidates/list/all/search
			?pageNo=${pageNo}&amp;limit=${limit}&state=${filters.state}&district=${filters.district}&srcofregister=${filters.srcofregister}&candidateId=${filters.candidateId}&locationSpoc=${filters.locationSpoc}&tpId=${filters.tpId}&startDate=${filters.endDate}&startDate=${filters.endDate}&amp;sortBy=candidateId&amp;sortOrder=1&keyword=${keyword ? `personalDetails.firstName:${keyword}` : ''
				}`;
			return this.apiService.post(url, filters);

		} else {
			const url = `${environment.userServiceUrl}/v1/candidates/list/all/search
				?pageNo=${pageNo}&amp;limit=${limit}&amp;sortBy=candidateId&amp;sortOrder=1&keyword=${keyword ? `personalDetails.firstName:${keyword}` : ''
				}`;
			return this.apiService.post(url, filters);

		}
		// const user = this.currentUserService.getCurrentUserLocal().value;
	}

	searchCandidatesV1(
		{ pageNo = 1, limit = 10, keyword = '' },
		filters?: ICandidateFilter
	) {
		/* searchs:-
			candidatesIDs,
			state,
			district,
			createdOn
		*/
		console.log(filters)
		filters = Object.keys(filters)
			.filter(filter => filters[filter])
			.reduce((finalFilter, filterKey) => {
				finalFilter[filterKey] = filters[filterKey];
				return finalFilter;
			}, {});
		if (filters.createdBy || filters.locationSpoc || filters.candidateId || filters.tpId || filters.srcofregister || filters.regType) {
			const url = `${environment.userServiceUrl}/v1/candidates/pmkvy/candidates/list
			?pageNo=${pageNo}&amp;limit=${limit}&state=${filters.state}&district=${filters.district}&srcofregister=${filters.srcofregister}&candidateId=${filters.candidateId}&locationSpoc=${filters.locationSpoc}&regType=${filters.regType}&tpId=${filters.tpId}&startDate=${filters.endDate}&startDate=${filters.endDate}&isEnrolledToBatch=${filters.isEnrolledToBatch}&amp;sortBy=candidateId&amp;sortOrder=1&keyword=${keyword ? `personalDetails.firstName:${keyword}` : ''
				}`;
			return this.apiService.post(url, filters);

		} else {
			const url = `${environment.userServiceUrl}/v1/candidates/pmkvy/candidates/list
				?pageNo=${pageNo}&amp;limit=${limit}&amp;sortBy=candidateId&amp;sortOrder=1&keyword=${keyword ? `personalDetails.firstName:${keyword}` : ''
				}`;
			return this.apiService.post(url, filters);

		}
		// const user = this.currentUserService.getCurrentUserLocal().value;
	}

	bulkUploadCandidate(file) {
		const user = this.currentUserService.getCurrentUserLocal().value;
		// const userName = user.userName;
		// const url = `${environment.userServiceUrl}/v1/candidates/reg/bulkupload/v2`;
		const url = `${environment.userServiceUrl
			}/v1/candidates/reg/bulkupload/tp/enroll`;
		const formData = new FormData();
		formData.append('file', file);
		return this.apiService.post(url, formData);
	}

	bulkUploadCandidateV2(file) {
		const user = this.currentUserService.getCurrentUserLocal().value;
		// const userName = user.userName;
		// const url = `${environment.userServiceUrl}/v1/candidates/reg/bulkupload/v2`;
		const url = `${environment.userServiceUrl}/v1/candidates/reg/bulkupload/tp/enrollV2`;
		const formData = new FormData();
		formData.append('file', file);
		return this.apiService.post(url, formData);
	}

	bulkuploadforQuickRegistration(file) {
		const url = `${environment.userServiceUrl}/v1/candidates/quickreg/bulkupload/tp`;
		const formData = new FormData();
		formData.append('file', file);
		return this.apiService.post(url, formData);
	}

	getSelectedSchemeTrainingCentres(selectedSchemeId, {
		pageNo = 1,
		limit = 10,
		pagination = 'yes'
	}) {
		const user = this.currentUserService.getCurrentUserLocal().value;
		const userName = user.userName;
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingcentres?Scheme=SchemeBased&SchemeId=${selectedSchemeId}`;
		return this.apiService.get(url);
	}

	addPmkvyProject(data: {}, tpId: string, role?: string, targetValidation?: boolean,
		approvalCount?: boolean, saveAsDraft?: boolean, deleteDraft?) {
		if (!targetValidation) {
			targetValidation = false;
		}
		if (!approvalCount) {
			approvalCount = false;
		}
		let url;
		switch (role) {
			case USER_ROLES.RPL_PMU:
			case USER_ROLES.SSDM_PMU_RPL:
			case USER_ROLES.STATE_SCHEME_PMU:
				url = `${environment.userServiceUrl}/api/user/v1/trainingpartner/${tpId}/scheme/pmkvy?role=${role}`
				break;
			case USER_ROLES.SSC_SCHEME_SPOC.ROLE:
				url = `${environment.userServiceUrl
					}/api/user/v1/trainingpartner/${tpId}/scheme/pmkvy?role=${role}&targetValidation=${targetValidation}`;
				break;
			default:
				url = approvalCount ?
					`${environment.userServiceUrl}/api/user/v1/trainingpartner/${tpId}/scheme/pmkvy?targetValidation=${targetValidation}&approvalCount=${approvalCount}&saveAsDraft=${saveAsDraft}`
					: `${environment.userServiceUrl}/api/user/v1/trainingpartner/${tpId}/scheme/pmkvy?targetValidation=${targetValidation}&saveAsDraft=${saveAsDraft}`
				break;
		}
		if (deleteDraft) {
			url += `&deleteDraft=${deleteDraft}`
		}
		// const url = role === USER_ROLES.RPL_PMU ? `${
		// 	environment.userServiceUrl
		// 	}/api/user/v1/trainingpartner/${tpId}/scheme/pmkvy?role=${role}` : `${
		// 	environment.userServiceUrl
		// 	}/api/user/v1/trainingpartner/${tpId}/scheme/pmkvy?&targetValidation=${targetValidation}`;
		return this.apiService.patch(url, data);
	}

	updateSignedTermsheet(projectID: number, signedUrl: string, role?) {
		const url = `${environment.userServiceUrl}/api/user/v1/trainingpartner/update/signed/termsheet?projectId=${projectID}&role=${role}`;
		return this.apiService.patch(url, { generatedSignedTermSheetPdf: signedUrl })
	}

	updateSignedTermsheetSp(projectID: number, signedUrl: string) {
		const url = `${environment.userServiceUrl}/api/user/v1/trainingpartner/update/signed/termsheet/sp?projectId=${projectID}`;
		return this.apiService.patch(url, { generatedSignedTermSheet: signedUrl })
	}

	/**
	 * GET
	 * Active Schemes
	 * @project Status
	 */
	getActiveSchemes(projectStatus: string, tpID: string, role: string, query?: any, type?: any) {
		// tslint:disable-next-line:max-line-length
		const url = `${environment.userServiceUrl}/api/user/v1/trainingpartner/active/schemes?tpid=${tpID}&projectStatus=${projectStatus}&role=${role}&type=${type}`;
		Object.keys(query).forEach((k) => query[k] == null && delete query[k]);  // REMOVE KEY IF VALUE IF EMPLTY
		return this.apiService.get(url, query || {});
	}

	checkTrainingCentreLocation(data) {
		const user = this.currentUserService.getCurrentUserLocal().value;
		const userName = user.userName;
		data.userName = userName;
		const url = `${environment.userServiceUrl}/api/user/v1/trainingpartner/verifylocation`;
		return this.apiService.post(url, data);

	}
	checkPanExistance(pan) {
		const PANURL = environment.userServiceUrl + '/api/user/v1/trainingpartner/get/pandetails';
		return this.apiService.post(PANURL, pan);
	}
	checkGstExistance(gst) {
		const URL = environment.userServiceUrl + '/api/user/v1/trainingpartner/get/gstdetails';
		return this.apiService.post(URL, gst);
	}

	/**
	 * @param trainingType
	 */
	getPmuList(trainingType: string) {
		const URL = `${environment.userServiceUrl}/api/user/v1/trainingpartner/pmu/list?type=${trainingType}`;
		return this.apiService.get(URL);
	}

	getTPProjectById(TPId, PID) {
		const URL = `${environment.userServiceUrl}/api/user/v1/trainingpartner/${TPId}/scheme/${PID}`;
		return this.apiService.get(URL);
	}

	getMonthWiseSummary(PID, currentMonth, currentYear, previousMonth = '', prevYear = '', projStDate, projEndDate, rplType) {
		// tslint:disable-next-line:max-line-length
		const URL = `${environment.userServiceUrl}/api/user/v1/trainingpartner/fetch/monthwise/summary?projectId=${PID}&currentMonth=${currentMonth}&currentYear=${currentYear}&previousMonth=${previousMonth}&previousYear=${prevYear}&projStDt=${projStDate}&projEdDt=${projEndDate}&rplType=${rplType}`;
		return this.apiService.get(URL);
	}

	getTpMprSingleById(PID, schemeID, reprt_date_id, tpId?) {
		const rep_date = new Date(reprt_date_id).toISOString();
		let URL;
		// rep_date = rep_date + 'Z';
		// tslint:disable-next-line:max-line-length
		if (tpId) {
		   URL = `${environment.userServiceUrl}/api/user/v1/trainingpartner/get/one/monthly/report?schemeId=${schemeID}&projectId=${PID}&reportDate=${rep_date}&tpId=${tpId}`;
		} else {
		   URL = `${environment.userServiceUrl}/api/user/v1/trainingpartner/get/one/monthly/report?schemeId=${schemeID}&projectId=${PID}&reportDate=${rep_date}`;
		}
		return this.apiService.get(URL);
	}

	getAllMPRs(schemeID, PID) {
		const URL = `${environment.userServiceUrl}/api/user/v1/trainingpartner/get/all/monthly/report?schemeId=${schemeID}&projectId=${PID}`;
		return this.apiService.get(URL);
	}

	addMPR(data) {
		const URL = environment.userServiceUrl + '/api/user/v1/trainingpartner/addmonthlyreport';
		return this.apiService.post(URL, data);
	}

	updateMPR(data, projectID, schemeID) {
		const URL = environment.userServiceUrl + `/api/user/v1/trainingpartner/editmonthlyreport?schemeId=${schemeID}&projectId=${projectID}`;
		return this.apiService.put(URL, data);
	}

	getVersionsHistory(projectId) {
		const url = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/project/history?projectId=${projectId}`
		this.apiService.get(url);
	}

	saveRplPmuComments(projectId: number, subScheme: number, data: any) {
		const url = `${environment.userServiceUrl}/api/user/v1/trainingpartner/update/pmu/detail?projectId=${projectId}&subScheme=${subScheme}`;
		return this.apiService.patch(url, data);
	}

	// API to download MPRs as pdf format
	downloadMprPdf(tpName, pid, reprtnth, projectType?) {
		const url = `${environment.pdfGenerate
			}/api/v1/generatepdfreports/generatemonthlyperformancereports?tpUserName=${tpName}&projectId=${pid}&reportMnth=${reprtnth}&projectType=${projectType}`
		return this.apiService.get(url);
	}

	checkSchemeRuleForTpType(scheme, isTpGovernment) {
		const govTidx = scheme.schemeDetails.trainingPartnerDetails.tpTypeDetails.findIndex(
			t => t.tpType.id === PMKVY_SCHEME_MODEL_CONSTANTS.TC_GOVERNMENT.id
		)
		const nonGovTidx = scheme.schemeDetails.trainingPartnerDetails.tpTypeDetails.findIndex(
			t => t.tpType.id !== PMKVY_SCHEME_MODEL_CONSTANTS.TC_GOVERNMENT.id
		)
		if ((govTidx !== -1 && nonGovTidx !== -1)) {
			this.tpTypeCheckForSchemRule.createProject = true;
			return this.tpTypeCheckForSchemRule;
		} else if (govTidx !== -1 && nonGovTidx === -1) {
			if (isTpGovernment) {
				this.tpTypeCheckForSchemRule.createProject = true;
				return this.tpTypeCheckForSchemRule;
			} else {
				this.tpTypeCheckForSchemRule.govError = true;
				return this.tpTypeCheckForSchemRule;
			}
		} else if ((govTidx === -1 && nonGovTidx !== -1)) {
			// if (!isTpGovernment) {
			this.tpTypeCheckForSchemRule.createProject = true;
			return this.tpTypeCheckForSchemRule;
			// } else {
			// 	this.tpTypeCheckForSchemRule.nonGovError = true;
			// 	return this.tpTypeCheckForSchemRule;
			// }
		}
	}

	getTentativePayoutCost(schemeId: any, projectId: number, jobRole: any) {
		const URL = `${environment.userServiceUrl}/api/user/v1/tentativepayout/calculation?schemeId=${schemeId}&projectId=${projectId}`;
		return this.apiService.post(URL, jobRole);
	}

	getConsumedTargetByLocation(stateId: number, districtId: number, projectId: any, qpCode?, tpId?, qpVersion?) {
		let url;
		if (qpCode) {
			url = `${environment.userServiceUrl}/api/batch/v1/batchsize/tp/
		pmkvyscetors/jobroles/td/tclist?stateId=${stateId}&districtId=${districtId}&projectId=${projectId}&qpCode=${encodeURIComponent(qpCode)}&qpVersion=${qpVersion}&tpId=${tpId}`;
		} else {
			url = `${environment.userServiceUrl}/api/batch/v1/batchsize/tp/
		pmkvyscetors/jobroles/td/tclist?stateId=${stateId}&districtId=${districtId}&projectId=${projectId}&tpId=${tpId}`;
		}
		return this.apiService.get(url);
	}

	getTentativeCostOfProject(tpId: string, projectId: number, role: string, schemeId: any, data: any, status?: any) {
		const URL = `${environment.userServiceUrl}/api/user/v1/get/sum/individual/tentativecost?
		tpId=${tpId}&projectId=${projectId}&role=${role}&schemeId=${schemeId}&status=${status}`;
		return this.apiService.post(URL, data);
	}
	getskillingCategory() {
		const URL = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/skillingcategory?scheme=feeBased`;
		return this.apiService.get(URL);
	}

	getTpDetailsById(role, id) {
		const URL = `${environment.userServiceUrl}/api/user/v1/getUserBasedOnRoleAndIds?ids=${id}&role=${role}`;
		return this.apiService.get(URL);
	}

	// Fee-based Implementation in FDA-CMA
	getLinkedAssessorsByTpId(pageNo, itemsPerPage) {
		// tslint:disable-next-line: max-line-length
		const url = `${environment.userServiceUrl}/api/user/v1/assessor/assessmentagency/getlinkedassessors?pageNo=${pageNo}&limit=${itemsPerPage}`;
		return this.apiService.get(url)
	}

	getTrainersByTpId(pageNo, itemsPerPage, tpId) {
		// tslint:disable-next-line: max-line-length
		const url = `${environment.trainingPartnerServiceURL}/api/trainingpartnerservice/v1/trainingpartner/${tpId}/trainers?pageNo=${pageNo}&limit=${itemsPerPage}`;
		return this.apiService.get(url);
	}

	getTrainingCentersByTpId(tpId, pageNo, itemsPerPage, schemeId?) {
		// tslint:disable-next-line: max-line-length
		const url = `${environment.userServiceUrl}/api/user/v1/trainingcentres?query=trainingPartner.userName:${tpId}&noPagination=yes&pageNo=${pageNo}&limit=${itemsPerPage}&SchemeId=${schemeId ? schemeId : ''}`;
		return this.apiService.get(url);
	}
	getAllTcs() {
		const URL = `${environment.userServiceUrl}/api/user/v1/get/tc/locations/info`;
		return this.apiService.get(URL);
	}

	getAccredetionData(tcId) {
		const URL = `${environment.userServiceUrl}/api/user/v1/trainingcentre/accrededition/dates?tcId=${tcId}`;
		return this.apiService.get(URL);
	}

	getTpJobRolesForTc(projectId: string, tpId?: string, pageNum?:number, limit?:number) {
		const URL = `${environment.userServiceUrl}/api/user/v1/trainingcentre/${tpId}/pmkvySectors/${projectId}?pageNo=${pageNum}&limit=${limit}`;
		return this.apiService.get(URL);
	}

	getCompletedTarget(tcId, projectId, qpCode, qpVersion) {
		const URL = `${environment.userServiceUrl}/api/user/v1/trainingcentres/project/jobrolewise/consumed/target?projectId=${projectId}&tcId=${tcId}&qpCode=${qpCode}&qpVersion=${qpVersion}`;
		return this.apiService.get(URL)
	}

	checkShowCause(data?) {
		const URL = `${environment.userServiceUrl}/api/user/v1/tp/tc/showcause/validation`;
		return this.apiService.get(URL, data)
	}


	updateSectorData(data) {
		const url = `${environment.userServiceUrl}/api/user/v1/trainingpartner/FeeBasedScheme/ResubmitSector/${data.id}`
		return this.apiService.put(url, data)
	}

	getAutoPopulateUserName(data) {
		const URL = `${environment.userServiceUrl}/api/user/v1/sourceofregister/info`;
		return this.apiService.post(URL, data);
	}


	getConsumedTargetByJobroleSP(projectId, qpcode, qpVersion) {
		const qpCode = encodeURIComponent(qpcode)
		const URL = `${environment.userServiceUrl}/api/user/v1/consumed/jobrole/target/sp?qpCode=${qpCode}&projectId=${projectId}&qpVersion=${qpVersion}`
		return this.apiService.get(URL)
	}
	// TP is in REDA or not
	isAppliedToREDA(tpID) {
		const tpreda = `${environment.userServiceUrl
			}/api/user/v1/trainingpartner/isappliedreda/${tpID}`;
		return this.apiService.get(tpreda);
	}
	// rpl job role deletion
	rplJobRoleDeletion(projectId, tpId, sectorId, qpCode, rpltype, deletedBy) {
		const queryParams = {
			projectId: projectId,
			tpId: tpId,
			sectorId: sectorId,
			qpCode: encodeURIComponent(qpCode),
			rpltype: rpltype,
			deletedBy: deletedBy
		};
		const URL = `${environment.userServiceUrl}/api/user/v1/deassociate/project/jobrole/rpl?projectId=${projectId}&tpId=${tpId}&rpltype=${rpltype}&deletedBy=${deletedBy}&sectorId=${sectorId}&qpCode=${qpCode}`;
		return this.apiService.delete(URL)
	}
	// rpl location delete
	rplLocationDeletion(projectId, tpId, rpltype, deletedBy, stateId, districtId) {
		const queryParams = {
			projectId: projectId,
			tpId: tpId,
			rpltype: rpltype,
			deletedBy: deletedBy,
			stateId: stateId,
			districtId: districtId
		};
		const URL = `${environment.userServiceUrl}/api/user/v1/delete/project/jobrole/location/rpl?projectId=${projectId}&tpId=${tpId}&rpltype=${rpltype}&deletedBy=${deletedBy}&stateId=${stateId}&districtId=${districtId}`;
		return this.apiService.delete(URL)
	}
	getTPStaus() {
		const URL = `${environment.userServiceUrl}
		/api/user/v1/blockaccessoftptc`;
		return this.apiService.get(URL)
	}
	getTPPAN() {
		const URL = `${environment.userServiceUrl}
		/api/user/v1/tp/pan/eligibleforpan`;
		return this.apiService.get(URL)
	}
	submitTPPan(panData) {
		const URL = `${environment.userServiceUrl}
		/api/user/v1/tp/pan/applyforpan`;
		return this.apiService.post(URL, panData)
	}

	getCovidJobroleFromAATc(filter, pageNo?, itemsPerPage?, isJobroleChecking?) {
		/*
			query = {
				tpId: filter.tpId,
				tpId: filter.tcId,
				qpCode: filter.qpCode,
				stateId: filter.stateId,
				districtId: filter.districtId,
			}
		*/
		let query = filter || {};
		if (filter && filter.qpCode) {
			query['qpCode'] = filter.qpCode;
		}
		if (pageNo || itemsPerPage) {
			query['pageNo'] = pageNo;
			query['size'] = itemsPerPage;
		}
		if (isJobroleChecking) {
			query['jobRoleChecking'] = isJobroleChecking;
		}
		const url = `${environment.userServiceUrl}/api/user/v1/trainingcentres/list/covidScheme`
		return this.apiService.get(url, query);
	}

	getUploadedExcelDataList(data) {
		const URL = `${environment.userServiceUrl}
		/v1/candidates/get/excel/candidates`;
		return this.apiService.get(URL, data)
	}

	getUploadedExcelData(excelId) {
		const URL = `${environment.userServiceUrl}
		/v1/candidates/get/excel/candidates?excelId=${excelId}`;
		return this.apiService.get(URL);
	}

	bulkCandidateUploadCovid(file) {
		const url = `${environment.userServiceUrl}
		/v1/candidates/upload/excel/candidates?`;
		const formData = new FormData();
		formData.append('file', file);
		return this.apiService.post(url, formData);
	}

	bulkCandidateUpdateCovid(file, excelId) {
		const url = `${environment.userServiceUrl}
		/v1/candidates/update/excel/candidates/${excelId}`;
		const formData = new FormData();
		formData.append('file', file);
		return this.apiService.post(url, formData);
	}


	validateUploadedExcelData(excelId) {
		const URL = `${environment.userServiceUrl}
		/v1/candidates/validate/excel/candidates/${excelId}`;
		return this.apiService.post(URL);
	}

	submitCandidateExcelData(excelId) {
		const URL = `${environment.userServiceUrl}/v1/candidates/submit/excel/candidates/${excelId}`;
		return this.apiService.post(URL);
	}

	getSubmittedExcelDataList(data) {
		const URL = `${environment.userServiceUrl}
		/v1/candidates/submitted/excel/candidates`;
		return this.apiService.get(URL, data);
	}

	getSubmittedExcelCandidateList(batchId, pageNo, limit) {
		const URL = `${environment.userServiceUrl}
		/v1/candidates/submitted/excel/candidates?batchId=${batchId}&pageNo=${pageNo}&limit=${limit}`;
		return this.apiService.get(URL);
	}

	updateAadhaarUploadedExcelData(payload) {
		const URL = `${environment.userServiceUrl}
		/v1/candidates/verify/excelCandudateAadhar`;
		return this.apiService.put(URL, payload);
	}

	updateProfilePhotoUploadedExcelData(payload) {
		const URL = `${environment.userServiceUrl}
		/v1/candidates/excel/uploadprofilephoto`;
		return this.apiService.put(URL, payload);
	}

	getMarksData(batchId, candidateId) {
		const URL = `${environment.userServiceUrl}
		/v1/candidates/submitted/excel/candidates/${batchId}/${candidateId}`;
		return this.apiService.get(URL);
	}
	getSubmittedExcelCandidateListExcel(batchId) {
		const excelUrl = `${environment.userServiceUrl}
		/v1/candidates/submitted/excel/candidates?batchId=${batchId}&download=${true}`;
		return this.apiService.getBlob(
			excelUrl,
			"application/CandidateDetails",
		);
	}
	uploadMarksOfExcelCandidate(payload) {
		const URL = `${environment.userServiceUrl}
		/v1/candidates/cforwexcel/assessment/marks`;
		return this.apiService.put(URL, payload);
	}
	updateTCDetailsForC4W(data) {
		const URL = `${environment.userServiceUrl}/v1/candidates/cforwexcel/batch/update`;
		return this.apiService.put(URL, data);
	}
	checkEntityExists(data) {
		const URL = `${environment.userServiceUrl}/api/user/v1/Validate/FinancialEntityValue`;
		return this.apiService.get(URL, data);
	}
	checkGSTExists(query) {
		const URL = `${environment.userServiceUrl}/api/user/v1/Validate/GSTNumber`;
		return this.apiService.get(URL, query);
	}


	previewNFCertificate(reqType, data) {
		const url = `${environment.batchServiceUrl}/api/v1/cert/certificate/preview/tpdummy?reqType=${reqType}`;
		return this.apiService.post(url, data);
	}

	thirdPartyAgencyLogoUpload(payload) {
		const url = `${environment.batchServiceUrl}/api/v1/cert/logoupload/thirdpartylogo`;
		return this.apiService.post(url, payload);
	}

	getInstantiatedQps(payload) {
		const URL = `${environment.trainingPartnerServiceURL}/api/trainingpartnerservice/v1/get/instantiatedqps?schemeId=${payload.schemeId}&trainingType=${payload.trainingType}`;
		return this.apiService.get(URL)
	}

	tpCRSDonarLogoUpload(payload) {
		const url = `${environment.batchServiceUrl}/api/v1/cert/logoupload/tpcrslogo`;
		return this.apiService.post(url, payload);
	}

	getTPCRSDonarDetails(payload?) {
		const url = `${environment.batchServiceUrl}/api/v1/cert/logoupload/getCrsDetails`;
		return this.apiService.get(url, payload);
	}

	updateTPCSRFonarStatus(payload) {
		const url = `${environment.batchServiceUrl}/api/v1/cert/logoupload/updatetpcrsLogo`;
		return this.apiService.post(url, payload);
	}

	cscCandidateLogin(payload){
		const url = `${environment.trainingPartnerServiceURL}/api/trainingpartnerservice/v1/get/csc/loggedin/user`;
		return this.apiService.post(url, payload);
	}

	getCSCCandidateList(payload){
		let url = `${environment.trainingPartnerServiceURL}/api/trainingpartnerservice/v1/get/csc/candidates?
		authenticatedBy=${payload.authenticatedBy}&tradeName=${payload.tradeName}&cscId=${payload.cscId}&pageNo=${payload.pageNo}&limit=${payload.limit}&status=${payload.status}
		&stateId=${payload.stateId}&districtId=${payload.districtId}&candidateStatus=${payload.candidateStatus}&pmvId=${payload.pmvId}&locationSpoc=${payload.locationSpoc}`;
		return this.apiService.get(url);
	}

	submitTCPreferences(payload){
		const URL = `${environment.trainingPartnerServiceURL}/api/trainingpartnerservice/v1/add/csc/candidate/preference`;
		return this.apiService.post(URL, payload);
	}

	getCandidateDetails(candidateId){
		const URL = `${environment.trainingPartnerServiceURL}/api/trainingpartnerservice/v1/get/csc/candidate/${candidateId}`;
		return this.apiService.get(URL);
	}


	updatePmvTpTcDeclaration(payload) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/tptcpmvdeclaration`;
		return this.apiService.post(URL, payload)
	}

	// bulkCandidateUploadCovid(payload?) {
	// 	const URL = `${environment.userServiceUrl}
	// 	/v1/candidates/upload/excel/candidates`;
	// 	return this.apiService.post(URL, payload)
	// } /validate/excel/candidates/{excelId}
}


interface ICandidateFilter {
	candidateId?: string;
	state?: string;
	district?: string;
	createdOn?: string;
	startDate?: string;
	endDate?: string;
	locationSpoc?: string;
	createdBy?;
	tpId?: string;
	srcofregister?: string;
	regType?: string;
	isEnrolledToBatch?: boolean;
}


